module.exports = __webpack_public_path__ + "img/text-center-active.cf264437.svg";